// extracted by mini-css-extract-plugin
module.exports = {"container":"CampaignActivation_container__1etp5","dummy":"CampaignActivation_dummy__2ANKn","go_button":"CampaignActivation_go_button__2SG6i"};